import React, { useState } from 'react';
import axios from 'axios';
import './styles.scss';
import charcaters from '../../../assets/images/dummy&friend.png';
import { Trans } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronLeft, faChevronRight, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function LoginForm({ withCode, setIsLoginLoading, external, setIsUserLogged }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [forgotPassword, setForgotPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [code, setCode] = useState('');

    const navigate = useNavigate();
    
    // const Auth = (e) => {
    //     setIsLoginLoading(true);
    //     e.preventDefault();
    //     axios.post(`${process.env.REACT_APP_DOMAIN_API}:${process.env.REACT_APP_DOCKER_API_PORT}/api/login`, {
    //         email: email,
    //         password: password
    //     })
    //     .then ((response) => {
    //         if (response.status === 200) {
    //             setIsUserLogged(true);
    //             localStorage.setItem('user', response.data.firstName);
    //             localStorage.setItem('userid', response.data.id);
    //             localStorage.setItem('credentials', response.data.token);
    //             navigate('/');
    //         }
    //     })
    //     .catch ((err) => {
    //         setIsUserLogged(false);
    //         if (err.status === 401) {
    //             throw new Error(`${err.data} ${err.status}`);
    //         } else if (err.status === 404) {
    //             throw new Error(`${err.data} ${err.status}`);
    //         } else if (err.status === 500) {
    //             throw new Error(`${err.data} ${err.status}`);
    //         }
    //         navigate('/login');
    //     })
    //     .finally(() => {
    //         setIsLoginLoading(false);
    //     })
    // }

    const AccessWithCode = (e) => {
        setIsLoginLoading(true);
        e.preventDefault();
        axios.post(`${process.env.REACT_APP_DOMAIN_API}:${process.env.REACT_APP_DOCKER_API_PORT}/api/user_acces_code`, {
            code: code
        })
        .then ((response) => {
            navigate('/')
            if (response.status === 200) {
                setIsUserLogged(true);
                localStorage.setItem('user', response.data.firstName);
                localStorage.setItem('userid', response.data.id);
                localStorage.setItem('cleint', response.data.cleint);
                localStorage.setItem('credentials', response.data.token);
                localStorage.setItem('mode', 'code');
                toast.success('Bienvenue !');
            }
        })
        .catch ((err) => {
            navigate('/testInterne');
            setIsUserLogged(false);
            if (err.status === 401) {
                throw new Error(`${err.message} ${err.status}`);
            } else if (err.status === 404) {
                throw new Error(`${err.message} ${err.status}`);
            } else if (err.status === 500) {
                throw new Error(`${err.message} ${err.status}`);
            }
            toast.error('Erreur de connexion');
        })
        .finally(() => {
            setIsLoginLoading(false);
        })
    }

    const AccessWithCodeSms = (e) => {
        setIsLoginLoading(true);
        e.preventDefault();
        axios.post(`${process.env.REACT_APP_DOMAIN_API}:${process.env.REACT_APP_DOCKER_API_PORT}/api/user_acces_code_sms`, {
            code: code,
            phoneNumber: localStorage.getItem('phone'),
            cleint: localStorage.getItem('cleint')
        })
        .then ((response) => {
            navigate('/')
            if (response.status === 200) {
                setIsUserLogged(true);
                localStorage.setItem('user', response.data.firstName);
                localStorage.setItem('userid', response.data.id);
                localStorage.setItem('credentials', response.data.token);
                localStorage.setItem('mode', 'jeton');
                toast.success('Bienvenue !');
            }
        })
        .catch ((err) => {
            navigate('/testExterne');
            setIsUserLogged(false);
            if (err.status === 401) {
                throw new Error(`${err.message} ${err.status}`);
            } else if (err.status === 404) {
                throw new Error(`${err.message} ${err.status}`);
            } else if (err.status === 500) {
                throw new Error(`${err.message} ${err.status}`);
            }
            toast.error('Erreur de connexion');
        })
        .finally(() => {
            setIsLoginLoading(false);
        })
    }

  return (
      <div className="LoginForm">
        <div className="LoginForm-images">
            <img className="LoginForm-image" src={charcaters} alt="Copine de Dummy et Dummy" />
        </div>
        {/* {!forgotPassword && !withCode && (
            <>
                <h2 className="LoginForm-welcome">
                    <Trans>Login.Welcome</Trans> !
                </h2>
                <form onSubmit={Auth} className="LoginForm-form">
                    <label className="LoginForm-form--label" htmlFor="email">E-mail</label>
                    <input 
                    className="LoginForm-form--input"
                    id='email' 
                    type="email" 
                    name="email" 
                    value={email} 
                    onChange={e => {
                        setEmail(e.target.value);
                    }}
                    />
                    <label className="LoginForm-form--label" htmlFor="password">
                        <Trans>Login.Password</Trans>
                    </label>
                    <input
                    className="LoginForm-form--input"
                    id='password' 
                    type={showPassword ? 'text' : 'password'} 
                    name="password" 
                    value={password}
                    onChange={e => {
                        setPassword(e.target.value);
                    }}
                    />
                    {!showPassword && (
                        <FontAwesomeIcon 
                            icon={faEyeSlash}
                            style={{
                            position: 'relative',
                            bottom: '2.5rem',
                            left: '18.7rem',
                            color: '#323BA2'
                            }}
                            onClick={() => {    
                                setShowPassword(!showPassword);
                            }} 
                        />
                    )}
                    {showPassword && (
                        <FontAwesomeIcon 
                            icon={faEye}
                            style={{
                                position: 'relative',
                                bottom: '2.5rem',
                                left: '18.8rem',
                                color: '#323BA2'
                            }}
                            onClick={() => {    
                                setShowPassword(!showPassword);
                            }} 
                        />
                    )}
                    <div className="LoginForm-form--buttons">
                        <button className="LoginForm-form--forgot-password" type="button" onClick={() => {
                            setForgotPassword(true);
                        }}>
                            <Trans>Login.Forgot</Trans> ?
                        </button>
                        <button className="LoginForm-form--submit" type="submit">
                            <Trans>Login.Login</Trans>
                            <FontAwesomeIcon icon={faChevronRight} style={{marginLeft: '1rem'}} />
                        </button>
                    </div>
                </form>
            </>
        )} */}
        {/* {forgotPassword && !withCode && (
            <>
                <h2 className="LoginForm-welcome">
                    <Trans>Login.Forgot</Trans> !
                </h2>
                <form action="" className="LoginForm-welcome">
                    <label className="LoginForm-form--label" htmlFor="email" style={{marginBottom: '-0.5rem'}}>Saisis l'e-mail avec lequel tu as créé ton compte</label>
                    <input 
                        className="LoginForm-form--input"
                        type="email" 
                        name='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        />
                        <div className="LoginForm-form--buttons">
                        <button className="LoginForm-form--forgot-password" type="button" onClick={() => {
                            setForgotPassword(false);
                        }}>
                            <FontAwesomeIcon icon={faChevronLeft} style={{marginRight: '1rem'}} />
                            Ecran de connexion
                        </button>
                        <button className="LoginForm-form--submit" type="submit">
                            <FontAwesomeIcon icon={faCheck} style={{marginRight: '1rem'}} />
                            Valider
                        </button>
                    </div>
                </form>
            </>
        )} */}

        {withCode && (
            <>
                <h2 className="LoginForm-welcome">
                    <Trans>Login.Welcome</Trans> !
                </h2>
                <form onSubmit={!external ? AccessWithCode : AccessWithCodeSms} className="LoginForm-welcome">
                    <label className="LoginForm-form--label" htmlFor="code" style={{marginBottom: '-0.5rem'}}>Code d'accès</label>
                    <input 
                        className="LoginForm-form--input"
                        type="code" 
                        name='code'
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                    />
                    <div className="LoginForm-form--buttons">
                        <button className="LoginForm-form--submit" type="submit">
                            <Trans>Login.Login</Trans>
                            <FontAwesomeIcon icon={faChevronRight} style={{marginLeft: '1rem'}} />
                        </button>
                    </div>

                </form>
            </>
        )}
        
    </div>
  );
}

export default LoginForm;
